import React, { useEffect } from "react";
import AsyncSelect from "react-select/lib/Async";
import { Controller } from "react-hook-form";
import LoadMask from "Utils/LoadMask/LoadMask";
import { NumberField } from "../../../../../Utils/renderField/fieldsHookForms";
import { usePesajeBascula } from "../../../../../Utils/APIs/usePesajeBascula";
import Alerta from "../../../../../Utils/Alerta/Alerta";
import CardEmpty from "Utils/Cards/CardEmpty";
import { useCreacionTraslado } from "../hooks/useCreacionTraslado";

export const TrasladoForm = (props) => {
    const { regresar, configuraciones, user } = props;

    const { pesoManual, pesoBascula } = usePesajeBascula({
        configuraciones,
        user,
    });

    const {
        formControl,
        formRegister,
        formSetValue,
        errors,

        cargando,
        CrearTraslado,
        loadAcopios,
        loadPilotos,
        loadVehiculos,
    } = useCreacionTraslado(regresar);

    useEffect(() => {
        if (!pesoManual && pesoBascula) {
            formSetValue("peso_tara", pesoBascula, {
                shouldDirty: true,
                shouldTouch: true,
                shouldValidate: true,
            });
        } else if (!pesoManual && !pesoBascula) {
            formSetValue("peso_tara", "", {
                shouldDirty: true,
                shouldTouch: true,
                shouldValidate: true,
            });
        }
    }, [pesoBascula, pesoManual]);

    return (
        <LoadMask loading={cargando} blur>
            <form>
                <div className="form-group grid-container">
                    <div className="form-group grid-container d-flex align-items-center flex-column">
                        <div className="col-12 col-lg-9">
                            <div className="d-flex mb-4 align-items-center">
                                <h6>
                                    DATOS GENERALES DE TRASLADO
                                </h6>
                            </div>
                            <div className="row col-md-12 p-0 d-flex flex-wrap">
                                <div className="col-md-6 p-0">
                                    <div className="col-12">
                                        <label htmlFor="fecha" className="m-0">
                                            FECHA DE CREACIÓN
                                        </label>
                                    </div>
                                    <div className="col-md-12  form-group">
                                        <input
                                            name="fecha"
                                            className="form-control"
                                            {...formRegister("fecha_creacion", {
                                                required:
                                                    "Este campo es obligatorio",
                                            })}
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6 p-0">
                                    <div className="col-12">
                                        <label
                                            htmlFor="vehiculo"
                                            className="m-0"
                                        >
                                            VEHÍCULO
                                        </label>
                                    </div>
                                    <div className="col-md-12  form-group">
                                        <Controller
                                            name="vehiculo"
                                            control={formControl}
                                            rules={{
                                                required:
                                                    "Debe seleccionar un vehículo",
                                            }}
                                            render={({ field }) => (
                                                <AsyncSelect
                                                    {...field}
                                                    className="react-select-container"
                                                    isSearchable
                                                    isClearable
                                                    cacheOptions
                                                    defaultOptions
                                                    loadOptions={loadVehiculos}
                                                    getOptionValue={(option) =>
                                                        option.id
                                                    }
                                                    getOptionLabel={(option) =>
                                                        option.nombre
                                                    }
                                                    onChange={(selected) => {
                                                        field.onChange(
                                                            selected,
                                                        );
                                                    }}
                                                />
                                            )}
                                        />
                                        {errors.vehiculo && (
                                            <small className="text-danger">
                                                {errors.vehiculo.message}
                                            </small>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="row col-md-12 p-0 d-flex flex-wrap">
                                <div className="col-md-6 p-0">
                                    <div className="col-12">
                                        <label htmlFor="piloto" className="m-0">
                                            PILOTO
                                        </label>
                                    </div>
                                    <div className="col-md-12 form-group">
                                        <Controller
                                            name="piloto"
                                            control={formControl}
                                            rules={{
                                                required:
                                                    "Debe seleccionar un piloto",
                                            }}
                                            render={({ field }) => (
                                                <AsyncSelect
                                                    {...field}
                                                    className="react-select-container"
                                                    isSearchable
                                                    isClearable
                                                    cacheOptions
                                                    defaultOptions
                                                    loadOptions={loadPilotos}
                                                    getOptionValue={(option) =>
                                                        option.id
                                                    }
                                                    getOptionLabel={(option) =>
                                                        option.nombre
                                                    }
                                                    onChange={(selected) => {
                                                        field.onChange(
                                                            selected,
                                                        );
                                                    }}
                                                />
                                            )}
                                        />
                                        {errors.piloto && (
                                            <small className="text-danger">
                                                {errors.piloto.message}
                                            </small>
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-6 p-0">
                                    <div className="col-12">
                                        <label
                                            htmlFor="vehiculo"
                                            className="m-0"
                                        >
                                            ACOPIO DESTINO
                                        </label>
                                    </div>
                                    <div className="col-md-12  form-group">
                                        <Controller
                                            name="acopio"
                                            control={formControl}
                                            rules={{
                                                required:
                                                    "Debe seleccionar un acopio",
                                            }}
                                            render={({ field }) => (
                                                <AsyncSelect
                                                    {...field}
                                                    className="react-select-container"
                                                    isSearchable
                                                    isClearable
                                                    cacheOptions
                                                    defaultOptions
                                                    loadOptions={loadAcopios}
                                                    getOptionValue={(option) =>
                                                        option.id
                                                    }
                                                    getOptionLabel={(option) =>
                                                        option.nombre
                                                    }
                                                    onChange={(selected) => {
                                                        field.onChange(
                                                            selected,
                                                        );
                                                    }}
                                                />
                                            )}
                                        />
                                        {errors.acopio && (
                                            <small className="text-danger">
                                                {errors.acopio.message}
                                            </small>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="row col-md-12 p-0 d-flex flex-wrap align-items-start">
                                <div className="col-md-6 form-group p-0">
                                    <CardEmpty noShadow noPadding>
                                        <div className="col-12 pt-2">
                                            <label
                                                htmlFor="peso_tara"
                                                className="m-0"
                                            >
                                                PESO TARA (Camión vacío)
                                            </label>
                                        </div>
                                        <div className="col-md-12 form-group">
                                            <NumberField
                                                control={formControl}
                                                name="peso_tara"
                                                errors={errors}
                                                allowNegative={false}
                                                suffix=" Kg"
                                                rules={{
                                                    required:
                                                        "Este campo es obligatorio",
                                                    min: {
                                                        value: 1,
                                                        message:
                                                            "Debe ser al menos 1",
                                                    },
                                                }}
                                                disabled={!pesoManual}
                                                decimalScale={0}
                                            />
                                        </div>
                                    </CardEmpty>
                                </div>
                                <div className="col-md-6 p-0">
                                    <div className="col-md-12 form-group d-flex align-content-center justify-content-center">
                                        <Alerta
                                            texto={
                                                pesoManual
                                                    ? `El peso se está tomando manualmente. Para tomarlo de báscula vaya a Configuración.`
                                                    : `El peso se está tomando automaticamente de Báscula. Para ingresarlo manualmente se debe ir a Configuración.`
                                            }
                                            noMarginBottom
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="buttons-box mt-5">
                        <button
                            type="button"
                            className="btn btn-outline-dark mr-5"
                            onClick={regresar}
                        >
                            CANCELAR
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={CrearTraslado}
                        >
                            CREAR TRASLADO
                        </button>
                    </div>
                </div>
            </form>
        </LoadMask>
    );
};
